import { useEffect } from "react";

import { getJiraContext } from "../services/jira-api";

const BACKGROUND_DESIGN_TOKEN = "--ds-surface";
const BACKGROUND_INPUT_DESIGN_TOKEN = "--ds-background-input";
const NEW_JIRA_UI_DARK_BACKGROUND = "#1F1F21";

export function useNewJiraUiBackground(colorMode?: string) {
  useEffect(() => {
    void (async () => {
      const { nav } = await getJiraContext();
      const tokensToSet = [BACKGROUND_DESIGN_TOKEN, BACKGROUND_INPUT_DESIGN_TOKEN];
      if (colorMode === "dark" && nav.isNewNavigation) {
        tokensToSet.forEach((token) => document.documentElement.style.setProperty(token, NEW_JIRA_UI_DARK_BACKGROUND));
      } else {
        tokensToSet.forEach((token) => document.documentElement.style.removeProperty(token));
      }
    })();
  }, [colorMode]);
}
